import CustomSelect from './base/CustomSelect.jsx'
import { fetchContactTypes } from '../../redux/actions/contactTypes.js'

const ContactTypeSelect = (props) => {
  const allProps = { ...props, fetchOptionsAction: () => fetchContactTypes(), selector: (state) => state["kpi"]["contactTypes"]  }
  return (
    <CustomSelect { ...allProps } />
  )
}

export default ContactTypeSelect
